import { MIXPANEL_PAGE_NAME, PAGE_NAME } from '../../../../constants';

export const source = [
    {
        src: 'https://cloudinary.fiverrcdn.com/video/upload/w_1.0,q_95/general_assets/categories/videos/fiverr_how_it_works_1.mp4',
        type: 'video/mp4',
    },
];

const videoName = 'Intro';

export const BIMeta = {
    mixpanel: {
        pageName: MIXPANEL_PAGE_NAME,
        videoName,
    },
    bigQuery: {
        pageName: PAGE_NAME,
        videoName,
    },
};
